export default "__VITE_ASSET__DMLZefPC__"